export default __webpack_public_path__ + "static/media/IMG_5510 copie.636a0034.jpg";